import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-237467de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row ui-espaco-campos" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  class: "",
  title: "Existe controle de acesso (entrada e saída) de pessoas e veículos?"
}
const _hoisted_5 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  style: {"display":"block","margin-top":"10px"},
  class: "ui-campo-instrucao"
}
const _hoisted_8 = {
  style: {"display":"block","margin-top":"10px"},
  class: "ui-campo-instrucao"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  class: "",
  title: "Observações"
}
const _hoisted_11 = { class: "ant-row ui-espaco-campos" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = {
  class: "",
  title: "Sistema de CFTV funcionando adequadamente?"
}
const _hoisted_14 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Número de câmeras", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Tempo de Gravação (DVR)", -1))
const _hoisted_22 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon" }, "dias", -1))
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  class: "",
  title: "Observações"
}
const _hoisted_27 = { class: "ant-row ui-espaco-campos" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_29 = {
  class: "",
  title: "Alarmes periféricos de monitoramento, sensores presença nas áreas internas ou externas?"
}
const _hoisted_30 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  class: "",
  title: "Observações"
}
const _hoisted_33 = { class: "ant-row ui-espaco-campos" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_35 = {
  class: "",
  title: "Vigilância patrimonial ?"
}
const _hoisted_36 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  class: "",
  title: "Observações"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "SEÇÃO 6 – SEGURANÇA PATRIMONIAL E MONITORAMENTO",
    "class-titulo": 'ui-card-info-titulo-rope'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao6.controleAcessoVisivel,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedSecao6.controleAcessoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao6.controleAcessoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao6.controleAcessoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao6.controleAcessoEnviarEmail,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedSecao6.controleAcessoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao6.controleAcessoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe controle de acesso (entrada e saída) de pessoas e veículos? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('controleAcesso')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao6.controleAcessoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao6.controleAcesso,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.computedSecao6.controleAcesso = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao6.controleAcessoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao6.controleAcesso,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.computedSecao6.controleAcesso = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.controleAcesso)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.ManualPreenchimentoInspecao.controleAcesso), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao6.controleAcessoVisivel && _ctx.computedSecao6.controleAcesso))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, [
                        _createTextVNode("Possui biometria, catraca ou TAG? "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao6.controleAcessoBiometriaOuCatraca,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.computedSecao6.controleAcessoBiometriaOuCatraca = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sim")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: !_ctx.computedSecao6.controleAcessoBiometriaOuCatraca,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.computedSecao6.controleAcessoBiometriaOuCatraca = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Não")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("span", _hoisted_8, [
                        _createTextVNode("Cadastro de visitantes e prestadores? "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao6.cadastroVisitantesPrestadores,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.computedSecao6.cadastroVisitantesPrestadores = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sim")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: !_ctx.computedSecao6.cadastroVisitantesPrestadores,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.computedSecao6.cadastroVisitantesPrestadores = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Não")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao6.controleAcessoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao6.controleAcessoObservacoesVisivel,
                              "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedSecao6.controleAcessoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao6.controleAcessoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao6.controleAcessoObservacoes,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedSecao6.controleAcessoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao6.sistemaCftvFuncionandoVisivel,
                        "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedSecao6.sistemaCftvFuncionandoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao6.sistemaCftvFuncionandoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao6.sistemaCftvFuncionandoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao6.sistemaCftvFuncionandoEnviarEmail,
                            "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedSecao6.sistemaCftvFuncionandoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao6.sistemaCftvFuncionandoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Sistema de CFTV funcionando adequadamente? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('sistemaCftvFuncionando')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao6.sistemaCftvFuncionandoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao6.sistemaCftvFuncionando,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.computedSecao6.sistemaCftvFuncionando = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao6.sistemaCftvFuncionandoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao6.sistemaCftvFuncionando,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.computedSecao6.sistemaCftvFuncionando = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.sistemaCftvFuncionando)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.ManualPreenchimentoInspecao.sistemaCftvFuncionando), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao6.sistemaCftvFuncionandoVisivel && _ctx.computedSecao6.sistemaCftvFuncionando))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedSecao6.cftvNumeroCameras) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_19), [
                            [_vModelText, _ctx.computedSecao6.cftvNumeroCameras]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("span", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.computedSecao6.cftvTempoGravacaoDias) = $event)),
                              disabled: _ctx.props.bloquearCampos
                            }, null, 8, _hoisted_23), [
                              [_vModelText, _ctx.computedSecao6.cftvTempoGravacaoDias]
                            ]),
                            _hoisted_24
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao6.sistemaCftvFuncionandoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao6.sistemaCftvFuncionandoObservacoesVisivel,
                              "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedSecao6.sistemaCftvFuncionandoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao6.sistemaCftvFuncionandoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao6.sistemaCftvFuncionandoObservacoes,
                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.computedSecao6.sistemaCftvFuncionandoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao6.alarmesPerifericosSensoresVisivel,
                        "onUpdate:checked": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.computedSecao6.alarmesPerifericosSensoresVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao6.alarmesPerifericosSensoresVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao6.alarmesPerifericosSensoresEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao6.alarmesPerifericosSensoresEnviarEmail,
                            "onUpdate:checked": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.computedSecao6.alarmesPerifericosSensoresEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao6.alarmesPerifericosSensoresEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Alarmes periféricos de monitoramento, sensores presença nas áreas internas ou externas? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('alarmesPerifericosSensores')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao6.alarmesPerifericosSensoresVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao6.alarmesPerifericosSensores,
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.computedSecao6.alarmesPerifericosSensores = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao6.alarmesPerifericosSensoresVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao6.alarmesPerifericosSensores,
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.computedSecao6.alarmesPerifericosSensores = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.alarmesPerifericosSensores)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.ManualPreenchimentoInspecao.alarmesPerifericosSensores), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao6.alarmesPerifericosSensoresVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao6.alarmesPerifericosSensoresObservacoesVisivel,
                              "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.computedSecao6.alarmesPerifericosSensoresObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao6.alarmesPerifericosSensoresObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao6.alarmesPerifericosSensoresObservacoes,
                            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.computedSecao6.alarmesPerifericosSensoresObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao6.vigilanciaPatrimonialVisivel,
                        "onUpdate:checked": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.computedSecao6.vigilanciaPatrimonialVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao6.vigilanciaPatrimonialVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao6.vigilanciaPatrimonialEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao6.vigilanciaPatrimonialEnviarEmail,
                            "onUpdate:checked": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.computedSecao6.vigilanciaPatrimonialEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao6.vigilanciaPatrimonialEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Vigilância patrimonial ? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('vigilanciaPatrimonial')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao6.vigilanciaPatrimonialVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao6.vigilanciaPatrimonial,
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.computedSecao6.vigilanciaPatrimonial = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao6.vigilanciaPatrimonialVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao6.vigilanciaPatrimonial,
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.computedSecao6.vigilanciaPatrimonial = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" - "),
                  ((_ctx.computedSecao6.vigilanciaPatrimonialVisivel && _ctx.computedSecao6.vigilanciaPatrimonial))
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 3,
                        checked: _ctx.computedSecao6.vigilanciaTipoPropria,
                        "onUpdate:checked": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.computedSecao6.vigilanciaTipoPropria) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Própria")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  ((_ctx.computedSecao6.vigilanciaPatrimonialVisivel && _ctx.computedSecao6.vigilanciaPatrimonial))
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 4,
                        checked: _ctx.computedSecao6.vigilanciaTipoTerceirizada,
                        "onUpdate:checked": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.computedSecao6.vigilanciaTipoTerceirizada) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Terceirizada")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.vigilanciaPatrimonial)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.ManualPreenchimentoInspecao.vigilanciaPatrimonial), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao6.vigilanciaPatrimonialVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao6.vigilanciaPatrimonialObservacoesVisivel,
                              "onUpdate:checked": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.computedSecao6.vigilanciaPatrimonialObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao6.vigilanciaPatrimonialObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao6.vigilanciaPatrimonialObservacoes,
                            "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedSecao6.vigilanciaPatrimonialObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}